import { createPool } from '@/api/asset/pool/create';
import Loading from '@/component/mui/Backdrop';
import { PoolSettingForm } from '@/component/pool-setting/Form';
import { PoolType } from '@/types';
import { Box, Button } from '@mui/material';
import { useState, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function CreatePool() {
  const [isLoading, setIsLoading] = useState(false);

  const [pools, setPools] = useState<PoolType>({
    symbol: 'SFL',
    title: '',
    description: '',
    address: '',
    contractAddr: '',
    period_sec: '0',
    periodMonth: '0',
    bonusPercent: '0',
    interestRate: '0',
    minUsdt: '0',
    maxUsdt: '0',
    goalUsdt: '0',
    goalMaxUsdt: '0',
    memo: '',
    waitStartDt: '',
    waitExpireDt: '',
    startDt: '',
    endDt: '',
    factoryId: '',
    isHide: 0,
    privateTokenSymbol: null,
    extraContractAddr: null,
  });
  const navigate = useNavigate();

  const onSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsLoading(true);
    // 풀이름 추가, 설명 추가, 최소스테이킹 금액(달러), 이자율, 모금 기간, 운영기간, 최소최대 함수 호출
    await handleContract();
  };
  const handleContract = async () => {
    try {
      await createPool(pools);
      toast.success('성공');
      setTimeout(() => {
        navigate('/pool-list');
      }, 2000);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          padding: 2,
        }}
      >
        <PoolSettingForm pools={pools} setPools={setPools} title="Create-Pool" type="create" />
        <Button variant="contained" onClick={onSubmit}>
          Create
        </Button>
      </Box>
      <Loading isLoading={isLoading} />
    </>
  );
}
